import { render, staticRenderFns } from "./ComicCard.vue?vue&type=template&id=ff76c9b8&scoped=true&"
import script from "./ComicCard.vue?vue&type=script&lang=js&"
export * from "./ComicCard.vue?vue&type=script&lang=js&"
import style0 from "./ComicCard.vue?vue&type=style&index=0&id=ff76c9b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff76c9b8",
  null
  
)

export default component.exports